import React from 'react';
import { Authenticator, View } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { I18n } from 'aws-amplify';
import { translations } from '@aws-amplify/ui-react';
import { Routes, Route, NavigateFunction, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import './App.css';
import SaggitaList from './pages/SaggitaList'
import SaggitaOnOff from './pages/SaggitaOnOff'
import SaggitaView from './pages/SaggitaView'
import AccountList from './pages/AccountList'
import NoMatch from './pages/NoMatch';

I18n.putVocabularies(translations);
I18n.setLanguage('ja');

I18n.putVocabulariesForLanguage(
  'ja', {
    'Username': '閲覧アカウントID',
    'Sign in': 'ログイン',
    'Enter your Username': '閲覧アカウントIDを入力',
    'Incorrect username or password.': '閲覧アカウントIDもしくはパスワードが正しくありません'
  }
);

const components = {
  SignIn: {
    Footer() {
      return (
        <View textAlign="center">
        </View>
      );
    }
  }
}

function proc(signOut: VoidFunction, navigate: NavigateFunction) {
  signOut();
  navigate('/');
}

function App() {
  const [saggitaViewLinkClass, setSaggitaViewLinkClass] = React.useState('nav-item active');
  const [saggitaViewLinkTextClass, setSaggitaViewLinkTextClass] = React.useState('nav-link text-white font-weight-bold');
  const [nextClass, setNextClass] = React.useState('nav-item');
  const [nextTextClass, setNextTextClass] = React.useState('nav-link text-white');
  const navigate = useNavigate();

  const saggitaViewLink = () => {
    setSaggitaViewLinkClass('nav-item active');
    setSaggitaViewLinkTextClass('nav-link text-white font-weight-bold');

    setNextClass('nav-item');
    setNextTextClass('nav-link text-white');
  }
  const onoffLink = () => {
    setSaggitaViewLinkClass('nav-item');
    setSaggitaViewLinkTextClass('nav-link text-white');

    setNextClass('nav-item active');
    setNextTextClass('nav-link text-white font-weight-bold');
  }

  return (
    <Authenticator components={components}>
      {({ signOut, user }) => (
        <div>
          <nav className="navbar navbar-expand fixed-top navbar-light admin-nab-color">
            <div className="container-fluid">
              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mr-auto">
                  <li className={saggitaViewLinkClass}>
                    <a className={saggitaViewLinkTextClass} aria-current="page" href="/">データ閲覧</a>
                  </li>
                  <li className={nextClass}>
                    <a className={nextTextClass} href="/saggita/onoff">接点切替</a>
                  </li>
                </ul>
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <a className="nav-link text-white active" href="#" onClick={() => proc(signOut!, navigate!)}>ログアウト</a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          {/* <main className=""> */}
          <main className="flex-shrink-0 pt-5">
            {/* <div className=""> */}
            <div className="container-fluid">
              <Routes>
                {/* <Route path="/" element={<SaggitaList signOut={signOut!} user={user!} activeLink={saggitaViewLink!} />} />
                <Route path="/saggita" element={<SaggitaList signOut={signOut!} user={user!} activeLink={saggitaViewLink!} />} />
                <Route path="/saggita/mng" element={<SaggitaMng activeLink={nextLink!} />} />
                <Route path="/next" element={<AccountList />} />
                <Route path="/xxxerr" element={<NoMatch />} /> */}
                <Route index path="/" element={<SaggitaView activeLink={saggitaViewLink!} user={user!} />} />
                <Route index path="/:id" element={<SaggitaView activeLink={saggitaViewLink!} user={user!} />} />
                <Route path="/saggita/onoff" element={<SaggitaOnOff activeLink={onoffLink!} user={user!} />} />
                <Route path="*" element={<NoMatch />} />
              </Routes>
            </div>
          </main>
        </div>
      )}
    </Authenticator>
  );
}

export default App;
